import { useState } from "react";
import { dataverseClient } from "../services/dataverseClient";

type RecordType = "contact" | "lead" | "account";

export function useCreateRecord() {
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const createRecord = async (type: RecordType, data: Record<string, string>) => {
    setCreating(true);
    setError(null);

    try {
      let id: string;
      if (type === "contact") {
        id = await dataverseClient.createContact(data as any);
      } else if (type === "lead") {
        id = await dataverseClient.createLead(data as any);
      } else {
        id = await dataverseClient.createAccount(data as any);
      }
      return id;
    } catch (err) {
      const e = err instanceof Error ? err : new Error("Failed to create record");
      setError(e);
      throw e;
    } finally {
      setCreating(false);
    }
  };

  return { createRecord, creating, error };
}
